<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('stockIn.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('stockIn.pageTitle'),
            href: '/admin/stock-in'
          },
          {
            text: $t('edit'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="ts-border ts-border-gray-300 ts-rounded-lg ts-p-3">
            <headerForm v-model="model" :validate="errors" />
          </div>
          <div
            class="ts-border ts-border-gray-300 ts-rounded-lg ts-p-3 ts-mt-4"
          >
            <ProductDetail v-model="model" :validate="errors" />
          </div>
          <div class="row ts-mt-4">
            <div class="col-md-12 ts-space-x-4 ts-flex ts-justify-end">
              <ts-button @click.prevent="$router.push({ name: 'stock-in' })">{{
                $t('cancel')
              }}</ts-button>
              <ts-button
                color="primary"
                :waiting="waiting"
                @click.prevent="onUpdate"
                >{{ $t('update') }}</ts-button
              >
            </div>
          </div>
        </ts-loading-banner>
        <!-- Purchase Type -->
        <a-modal
          :title="$t('purchaseOrder.createPurchaseType')"
          width="30%"
          v-model="add_new_purchase_type"
          :footer="null"
        >
          <div class="row">
            <label class="form-col-label control-label col-md-12">{{
              $t('purchaseOrder.purchaseType')
            }}</label>
            <div class="col-md-12">
              <input
                v-model="purchase_type_model.purchase_type"
                type="text"
                class="form-control"
              />
            </div>
          </div>
          <div class="row ts-mt-4">
            <div
              class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end"
            >
              <ts-button @click.prevent="() => (add_new_purchase_type = false)">
                {{ $t('cancel') }}
              </ts-button>
              <ts-button
                :waiting="waiting_new_purchase_type"
                @click.prevent="onSavePurchaseType"
                color="primary"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </div>
        </a-modal>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import Ponumber from './components/purchase-order-number'
import ProductDetail from './components/product-detail'
import headerForm from './components/header-form.vue'
import moment from 'moment'
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'stockInEdit',
  components: {
    Ponumber,
    ProductDetail,
    headerForm
  },
  data () {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      add_new_purchase_type: false,
      waiting_new_purchase_type: false,
      model: {
        stock_in_id: null,
        location_id: null,
        invoice_no: null,
        invoice_date: null,
        stock_in_date: moment().format('DD-MM-YYYY'),
        po_id: null,
        vendor_id: null,
        fx_rate: '',
        fx_bath: '',
        stock_in_warehouse_type: 'vendor',
        product_detail: [
          {
            product_id: null,
            uom_id: null,
            qty: 1,
            cost: 0,
            discount_rate: 0,
            discount_type: '%',
            total_after_discount: null,
            vat_rate: 0,
            vat_amount: 0,
            grand_total: 0,
            expiry_date: null,
            is_expire: false
          }
        ],
        remarks: null,
        customs_ref: null,
        customs_date: null,
        purchase_type_id: null,
        credit_day: 0,
        next_payment_date: null,
        pi_product_type: null
      },
      purchase_type_model: {
        purchase_type: null
      }
    }
  },
  async created () {
    this.loading = true
    await this.fetchResource()
    await this.find(this.$route.params.id)
      .then(() => this.setEditData())
      .finally(() => (this.loading = false))
  },
  computed: {
    ...mapState('stock/stockIn', ['edit_data']),
    ...mapGetters('stock/stockIn', ['isExpirable']),
    default_precision () {
      return this.$store.state.authUser.sys_setting.decimal_digit
    }
  },
  methods: {
    ...mapActions('stock/stockIn', ['fetchResource', 'update', 'find', 'getFormViewModel']),
    onSavePurchaseType () {
      this.waiting_new_purchase_type = true
      this.errors = new Errors()
      this.$store
        .dispatch('purchaseOrder/purchaseType/store', this.purchase_type_model)
        .then(async response => {
          this.$toasted.success(response.message)
          await this.$store.commit(
            'stock/stockIn/PUSH_NEW_PURCHASE_TYPE',
            response.data
          )
          this.model.purchase_type_id = data.purchase_type_id
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new_purchase_type = false
          this.add_new_purchase_type = false
        })
    },
    onUpdate () {
      this.waiting = true
      this.errors = new Errors()
      this.update({
        id: this.model.stock_in_id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'stock-in' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData () {
      this.model.stock_in_id = this.edit_data.stock_in_id
      this.model.location_id = this.edit_data.location_id
      this.model.invoice_no = this.edit_data.invoice_no
      this.model.invoice_date = this.edit_data.invoice_date
      this.model.stock_in_date = this.edit_data.stock_in_date
      this.model.po_id = this.edit_data.po_id
      this.model.vendor_id = this.edit_data.vendor_id
      this.model.fx_rate = this.edit_data.fx_rate
      this.model.fx_bath = this.edit_data.fx_bath ? this.edit_data.fx_bath : 32
      this.model.remarks = this.edit_data.remarks
      this.model.customs_ref = this.edit_data.customs_ref
      this.model.customs_date = this.edit_data.customs_date
      this.model.pi_product_type = this.edit_data.pi_product_type
      this.model.product_detail = this.edit_data.stock_in_details.map(el => ({
        product_id: el.product_id,
        uom_id: el.uom_id,
        qty: el.quantity,
        cost_in_bath: _.round(
          el.cost * this.model.fx_bath,
          this.default_precision
        ),
        cost: _.round(el.cost ? el.cost : 0, this.default_precision),
        discount_rate: el.discount_rate,
        discount_type: el.discount_type,
        total_after_discount: el.total_after_discount,
        vat_rate: Number(el.vat_rate) || 0,
        vat_amount: Number(el.vat_amount) || 0,
        grand_total: el.grand_total,
        expiry_date: el.expiry_date,
        is_expire: this.isExpirable(el.product_id),
        product_grade: el.product_grade,
        imei_list: el.imei_list
          ? el.imei_list.split(',').map((el, index) => ({ 0: el }))
          : null
      }))
      this.model.purchase_type_id = this.edit_data.purchase_type_id
      this.model.credit_day = this.edit_data.credit_day
      this.model.next_payment_date = this.edit_data.next_payment_date
      this.model.stock_in_warehouse_type =
        this.edit_data.stock_in_warehouse_type
      this.$store.commit(
        'stock/stockIn/MERGE_PURCHASEORDER',

        this.edit_data.purchase_order
      )
    },
    onVendorChange (value, opt) {
      this.model.credit_day = opt.data.props.credit_day
    },
    updateNextPaymentDate () {
      if (this.model.stock_in_date && this.model.credit_day > 0) {
        this.model.next_payment_date = moment(
          this.model.stock_in_date,
          'DD-MM-YYYY'
        )
          .add(this.model.credit_day, 'days')
          .format('DD-MM-YYYY')
      } else {
        this.model.next_payment_date = null
      }
    },
    onFetchExchangeRate() {
      this.loading = true
      return this.getFormViewModel({
        fnName: 'exchangeRate',
        stock_in_date: this.model.stock_in_date
      })
        .then((response) => {
          this.setExchangeRate(response.data.exchangeRate)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    setExchangeRate(data) {
      let fxRate = data.find(
        e => e.to_currency == 'KHR'
      )
      if (fxRate) {
        this.model.fx_rate = parseFloat(fxRate.fx_rate)
      }
      let fxBath = data.find(
        e => e.to_currency == 'THB'
      )
      if (fxBath) {
        this.model.fx_bath = parseFloat(fxBath.fx_rate)
      }
    }
  },
  watch: {
    'model.stock_in_date': function() {
      this.updateNextPaymentDate()
      this.onFetchExchangeRate()
    },
    'model.credit_day': function() {
      this.updateNextPaymentDate()
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('stock/stockIn/CLEAR_SETUP')
    this.$store.commit('stock/stockIn/SET_EDIT_DATA', {})
    next()
  }
}
</script>
